import { AxiosRequestConfig, AxiosResponse } from '../Axios';

// DataCache is a generic interface for cache implementations to be hooked with
// axios apis.
export interface DataCache {
  readonly name: string;
  canHandle(config: AxiosRequestConfig): boolean;
  handle<T = any, R = AxiosResponse<T>>(config: AxiosRequestConfig): Promise<R>;
}

// CacheManager manages cache instances. Used for backward compatibility with
// openui-framework as well as to share cache across applications in suite.
export class CacheManager {
  private store: Map<string, DataCache>;

  private constructor() {
    this.store = new Map<string, any>();
  }

  addCache(c: DataCache) {
    this.store.set(c.name, c);
  }

  getCache(n: string): DataCache | undefined {
    return this.store.get(n);
  }

  // findCache return cache that can handle input request, if any.
  findCache(c: AxiosRequestConfig): DataCache | undefined {
    if (this.store.size < 1) return;
    for (const entry of this.store) {
      if (entry[1].canHandle(c)) {
        return entry[1];
      }
    }
  }

  private static _instance: CacheManager;

  public static get instance(): CacheManager {
    if (CacheManager._instance === undefined) {
      CacheManager._instance = new CacheManager();
    }
    return CacheManager._instance;
  }
}
